import styled from '@emotion/styled';
import Container from '@ep/components/Container';
import { Body } from '@ep/templates/ProductPage';
import theme from '@ep/theme';
import { Gcms_Stat } from '@ep/types/gatsbyTypes';
import React from 'react';
import Stat from './Stat';

export interface StatsModuleProps {
  stats: Gcms_Stat[];
  statsCaption: string;
  statsBackgroundColor: string;
}

interface StyledContainerProps {
  statsLength: number;
}

const StyledContainer = styled(Container)<StyledContainerProps>`
  /*margin-top: 5rem !important;*/
  /*margin-bottom: 3rem;*/
  max-width: 100%;
  padding: 3rem;
  position: relative;
  text-align: center;
  @media (min-width: ${theme.breakpoints.tablet + 1000}px) {
    ${({ statsLength }) =>
      statsLength < 4 ? `max-width: 50%;` : `max-width: 80%;`}
  }
  ${theme.mediaQueries.mobile} {
    margin-top: 4rem !important;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-gap: 5rem 0px;
  justify-content: center;
  text-align: center;

  ${theme.mediaQueries.tablet} {
    grid-gap: 2rem 0px;
  }

  @media (max-width: ${theme.breakpoints.optimalTablet + 200}px) {
    grid-gap: 2rem 0px;
    grid-template-columns: repeat(1, 1fr) !important;
  }

  @media (max-width: ${theme.breakpoints.optimalMobile + 200}px) {
    grid-template-columns: minmax(0, 350px) !important;
    grid-gap: 2rem 10px;
  }
`;

const CaptionContainer = styled.p`
  margin-top: 2rem;
  padding: 0 20% 0% 20%;
  @media (max-width: ${theme.breakpoints.optimalMobile + 950}px) {
  }
  @media (max-width: ${theme.breakpoints.optimalMobile + 700}px) {
    margin: auto auto;
    margin-top: 2rem;
  }
  ${theme.mediaQueries.mobile} {
    width: 83%;
    margin-top: 2rem;
    padding: 0 10% 0% 10%;
  }
`;

function StatsModule({
  stats,
  statsCaption,
  statsBackgroundColor,
}: StatsModuleProps) {
  const statsLength = stats.length;
  return (
    <StyledContainer
      statsLength={stats.length}
      backgroundColor={statsBackgroundColor ? statsBackgroundColor.hex : ''}
    >
      <Grid style={{ gridTemplateColumns: 'repeat(' + statsLength + ', 1fr)' }}>
        {stats?.map((stat, index) => (
          <Stat key={`Stat__${stat.value}__${index}`} {...stat} key={index} />
        ))}
      </Grid>
      {statsCaption && (
        <Body>
          <CaptionContainer>{statsCaption}</CaptionContainer>
        </Body>
      )}
    </StyledContainer>
  );
}

export default React.memo(StatsModule);
